import { FORM_FIELD_FIELD_TYPES } from '../../constants/FormFields';
import CustomFormFieldCheckboxBoolean from './CustomFormFieldCheckboxBoolean';
import CustomFormFieldCheckboxMultiple from './CustomFormFieldCheckboxMultiple';
import CustomFormFieldDate from './CustomFormFieldDate';
import CustomFormFieldNumber from './CustomFormFieldNumber';
import CustomFormFieldPhone from './CustomFormFieldPhone';
import CustomFormFieldRadio from './CustomFormFieldRadio';
import CustomFormFieldSelect from './CustomFormFieldSelect';
import CustomFormFieldText from './CustomFormFieldText';
import CustomFormFieldTextArea from './CustomFormFieldTextArea';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormField = props => {
  const {
    fieldType
  } = props.formField;
  switch (true) {
    case fieldType === FORM_FIELD_FIELD_TYPES.PHONE_NUMBER:
      return /*#__PURE__*/_jsx(CustomFormFieldPhone, Object.assign({}, props));
    case fieldType === FORM_FIELD_FIELD_TYPES.NUMBER:
      return /*#__PURE__*/_jsx(CustomFormFieldNumber, Object.assign({}, props));
    case fieldType === FORM_FIELD_FIELD_TYPES.DATE:
      return /*#__PURE__*/_jsx(CustomFormFieldDate, Object.assign({}, props));
    case fieldType === FORM_FIELD_FIELD_TYPES.TEXTAREA:
      return /*#__PURE__*/_jsx(CustomFormFieldTextArea, Object.assign({}, props));
    case fieldType === FORM_FIELD_FIELD_TYPES.BOOLEAN_CHECKBOX:
      return /*#__PURE__*/_jsx(CustomFormFieldCheckboxBoolean, Object.assign({}, props));
    case fieldType === FORM_FIELD_FIELD_TYPES.CHECKBOX:
      return /*#__PURE__*/_jsx(CustomFormFieldCheckboxMultiple, Object.assign({}, props));
    case fieldType === FORM_FIELD_FIELD_TYPES.SELECT:
      return /*#__PURE__*/_jsx(CustomFormFieldSelect, Object.assign({}, props));
    case fieldType === FORM_FIELD_FIELD_TYPES.RADIO:
      return /*#__PURE__*/_jsx(CustomFormFieldRadio, Object.assign({}, props));
    default:
      return /*#__PURE__*/_jsx(CustomFormFieldText, Object.assign({}, props));
  }
};
export default CustomFormField;